import { create } from 'zustand';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';

export interface NotificationAction {
  label: string;
  href?: string;
  onClick?: () => void;
}

export interface Notification {
  id: string;
  message: string;
  severity: NotificationSeverity;
  action?: NotificationAction;
  autoHide?: boolean;
  autoHideDuration?: number;
}

interface NotificationState {
  notifications: Notification[];
  addNotification: (notification: Omit<Notification, 'id'>) => string;
  removeNotification: (id: string) => void;
  clearAll: () => void;
}

let notificationId = 0;

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],

  addNotification: (notification) => {
    const id = `notification-${++notificationId}`;
    const newNotification: Notification = {
      id,
      autoHide: true,
      autoHideDuration: 5000,
      ...notification,
    };
    set((state) => ({
      notifications: [...state.notifications, newNotification],
    }));
    return id;
  },

  removeNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },

  clearAll: () => {
    set({ notifications: [] });
  },
}));
